import { render, staticRenderFns } from "./create-survey.component.html?vue&type=template&id=6304c280&scoped=true&external"
import script from "./create-survey.component.ts?vue&type=script&lang=ts&external"
export * from "./create-survey.component.ts?vue&type=script&lang=ts&external"
import style0 from "./create-survey.component.scss?vue&type=style&index=0&id=6304c280&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6304c280",
  null
  
)

export default component.exports